import './modernizr.js'; //browser style imports require extension

import { clearTableLayout } from './modules/@helpers/js/clearLayoutProps.js';

import modules from './modules.js'; //browser style imports require extension

import { getStorage } from './modules/@helpers/js/keyvaluestorage.js';
getStorage().storeKeyValue('scriptUrl', import.meta.url);

/** construct a module form an element and possibly options
 * @param  moduleName     the name of the module to construct
 * @param  element  the element to inject into the module
 * @param  options  the optional options to give the module
 */
async function constructModuleFromElement(moduleName, element, options) {
    if (!moduleName || !element) {
        return;
    }
    if (modules[moduleName] && typeof modules[moduleName] === 'function') {
        return new modules[moduleName](element, options);
    }
}

function processModulesInsideElement(element) {
    if (!element || !element.querySelectorAll) {
        return;
    }
    const moduleElements = [...element.querySelectorAll('[data-module]')];
    moduleElements.forEach(el => {
        const dataModules = el.getAttribute('data-module');
        const names = dataModules && dataModules.indexOf(' ') > -1 ? dataModules.split(' ') : [dataModules];
        const optionsValue = el.getAttribute('data-options');
        let options;
        if (optionsValue && typeof optionsValue === 'string' && optionsValue.length > 2 && optionsValue.startsWith('{')) {
            try {
                options = JSON.parse(optionsValue);
            } catch (error) {
                console.error(error);
            }
        }
        names.forEach(name => constructModuleFromElement(name, el, options));
    });
    clearTableLayout(element);
}

window.activateModuleOnElement = constructModuleFromElement;
window.processModulesInsideElement = processModulesInsideElement;
processModulesInsideElement(document);
constructModuleFromElement('Datalayer', document);
